import React, { useEffect, useState } from 'react';
import { callNumberListing, deleteNumber } from '../../api-services';
import { Spinner } from '../../helper/Spinner';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Pagination from '../../helper/Pagination';
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import NumberDetails from './NumberDetails';
import { openModalGlobal } from '../../redux/features/modalSlice';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEye,
  faTrash,
  faEllipsisV,
  faRefresh,
  faPlay,
} from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import BarLoader from 'react-bar-loader';
import AudioPlayer from '../../components/AudioPlayer';
const Numbers = () => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();
  const [userDetailsModal, setUserDetailsModal] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [page, setPage] = useState(1);
  const {
    isLoading,
    isFetching,
    refetch,
    data: numberListing,
  } = useQuery(
    'numberListing',
    () =>
      callNumberListing({
        page: page,
      }),
    {
      refetchOnWindowFocus: false,
    },
  );

  const { mutateAsync: mutateAsyncdelete } = useMutation(
    'delete-number',
    deleteNumber,
    {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message ?? 'Success!',
          icon: 'success',
          type: 'success',
          timer: 2000,
        }).then(() => {
          queryClient.invalidateQueries('numberListing');
        });
      },
      onError: (error) => {
        swal({
          title: error?.response?.data?.message,
          type: 'danger',
          icon: 'error',
        });
      },
    },
  );
  useEffect(() => {
    refetch();
  }, [page]);

  const onChangePage = async (page) => {
    setPage(page);
  };

  const handleDeleteNumber = (val) => {
    swal({
      text: 'Are you sure you want to delete this Number ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          let payload = {
            didID: val?.didID,
          };
          await mutateAsyncdelete(payload);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const handleUserDetailsModal = (data) => {
    setUserDetails(data);
    setUserDetailsModal(true);
  };

  const handleProfit = (val) => {
    const { did_setup_cost, did_monthly_cost, amount } = val;
    const profit = amount - (did_setup_cost + did_monthly_cost);
    const inLose = Math.sign(profit);
    if (inLose === -1 || inLose === -0) {
      return (
        <a className="text-danger" href={void 0}>
          {profit.toFixed(2)}
        </a>
      );
    } else {
      return (
        <a className="text-success" href={void 0}>
          {profit.toFixed(2)}
        </a>
      );
    }
  };

  const handleOpenModal = (customer, account_number) => {
    if (!account_number) {
      return false;
    }
    dispatch(
      openModalGlobal({
        isOpen: true,
        isData: customer,
      }),
    );
  };

  const handleAudio = (url) => {
    if (url) {
      window.open(url);
    }
    return;
  };
  return (
    <>
      <div className="page_content">
        <section className="lower_section pt-2">
          <div className="page_heading page_heading_enhence d-flex justify-content-between align-items-center w-100 bg-white p-2">
            <h3>
              <span className="title">DID Numbers</span>
            </h3>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center justify-content-center  reload_icon"
              onClick={() => refetch()}
            >
              <FontAwesomeIcon icon={faRefresh} />
            </button>
          </div>
          <div className="row">
            <div className="col-md-12 ">
              <div className=" table-responsive position-relative">
                {(isLoading || isFetching) && (
                  <div className="custom-linear-loader-row">
                    <div className="custom-linear-loader" colSpan="13">
                      <BarLoader color="#000000" height="4px" />
                    </div>
                  </div>
                )}
                <table className="table table_custom table_custom_enhence  mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Number
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        MSISDN
                      </th>

                      <th style={{ width: '8.3%', textAlign: 'left' }}>
                        Country
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'left' }}>City</th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Buy Date
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Renewal Date
                      </th>

                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Setup Cost
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Monthly Cost
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Paid
                      </th>

                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Profit
                      </th>
                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Status
                      </th>

                      <th style={{ width: '8.3%', textAlign: 'center' }}>
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {numberListing &&
                    numberListing.data &&
                    numberListing.data.data &&
                    numberListing.data.data.length > 0 ? (
                      numberListing.data.data.map((val, index) => {
                        const {
                          customer,
                          did_number,
                          did_name,
                          did_setup_cost,
                          did_monthly_cost,
                          did_status,
                          amount,
                          renewal_date,
                          created_at,
                          msisdn,
                          buy_date,
                          greeting_url,
                          city,
                          country,
                        } = val;

                        return (
                          <tr key={index}>
                            <td align="center" style={{ width: '8.3%' }}>
                              {did_number ? did_number : '---'}
                            </td>
                            <td
                              onClick={() => handleOpenModal(customer, msisdn)}
                              style={{
                                width: '8.3%',
                                cursor: 'pointer',
                                textAlign: 'center',
                              }}
                            >
                              {msisdn ? msisdn : '---'}
                            </td>
                            <td align="left" style={{ width: '8.3%' }}>
                              {country ? country : '---'}
                            </td>
                            <td align="left" style={{ width: '8.3%' }}>
                              {city ? city : '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {buy_date || '---'}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {renewal_date ? renewal_date : '---'}
                            </td>

                            <td align="center" style={{ width: '8.3%' }}>
                              {did_setup_cost}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {did_monthly_cost}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {amount}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {handleProfit(val)}
                            </td>
                            <td align="center" style={{ width: '8.3%' }}>
                              {did_status === 'A' ? 'Activated' : 'Deactivated'}
                            </td>

                            <td align="center" style={{ width: '8.3%' }}>
                              <span>
                                <Dropdown className="dropdown_dot">
                                  <Dropdown.Toggle
                                    id="dropdown-basic"
                                    className="btn-light-blue btn-action "
                                  >
                                    <FontAwesomeIcon icon={faEllipsisV} />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      href={void 0}
                                      onClick={() =>
                                        handleUserDetailsModal(val)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faEye} />
                                      View
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      href={void 0}
                                      onClick={() => handleDeleteNumber(val)}
                                    >
                                      <FontAwesomeIcon icon={faTrash} />
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </span>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="13" align="center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 m-0 pagingWrap p-0 d-flex justify-content-between align-items-center">
                {numberListing &&
                numberListing.data &&
                numberListing.data.data &&
                numberListing.data.data.length > 0 ? (
                  <>
                    <div className="text-black d-flex align-items-center total_records justify-content-center">
                      Total
                      <span className="d-flex  mr-2 align-items-center  btn-primary  btn-sm ml-2">
                        {numberListing?.data?.totalRecords}
                      </span>
                      record(s)
                    </div>
                    <div>
                      <Pagination
                        pageSize={numberListing?.data?.lastPage}
                        items={numberListing?.data?.data}
                        onChangePage={onChangePage}
                        total={numberListing?.data?.totalRecords}
                        currentPage={page}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </section>
      </div>

      {userDetailsModal && (
        <NumberDetails
          userDetailsModal={userDetailsModal}
          setUserDetailsModal={setUserDetailsModal}
          userDetails={userDetails}
          setUserDetails={setUserDetails}
        />
      )}
    </>
  );
};

export default Numbers;
